export default __webpack_public_path__ + "static/icsl-5127202ed30b2f1cf126ddddea723a85.svg";